import React, { useState } from "react";

export default function HeroSection() {
  const [videoError, setVideoError] = useState(false);

  return (
    <section className="relative w-full h-[80vh] overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900">
      {/* Background video */}
      {!videoError && (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src="https://storage.googleapis.com/coverr-main/mp4/Trading.mp4"
          autoPlay
          muted
          loop
          playsInline
          onError={() => setVideoError(true)}
        />
      )}

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-[1px]" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <h1 className="text-4xl sm:text-6xl font-extrabold bg-gradient-to-r from-yellow-300 via-blue-400 to-purple-500 bg-clip-text text-transparent mb-4 animate-fadeIn">
          Verified Market Network
        </h1>
        <p className="text-slate-300 text-sm sm:text-lg max-w-xl animate-fadeIn">
          Build, trade, connect, and collaborate across 29+ verified categories
          and 200+ professional roles — powered by SmartCard identity.
        </p>
        <button className="mt-6 bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-2 rounded-full font-semibold hover:scale-105 transition animate-fadeIn">
          Explore the Network
        </button>
      </div>
    </section>
  );
}
